import React, { FunctionComponent } from 'react';
import UploadMusic from '../../video/music/upload-music/upload-music';

interface Props {
  onSelect: (musicUrl: string, name: string) => void;
  sceneId: string;
  itemIndex: number;
}

const MyAudio: FunctionComponent<Props> = ({
  onSelect,
  sceneId,
  itemIndex,
}) => {
  return (
    <div className="my-audio-container">
      <UploadMusic
        onSelect={onSelect}
        sceneId={sceneId}
        itemIndex={itemIndex}
      />
    </div>
  );
};

export default MyAudio;
